import { Grid, Typography } from "@material-ui/core";
import CustomDateField from "components/CustomDateField";
import SanitizedGrid from "components/SanitizedGrid";
import React from "react";
import {
  Datagrid,
  TextField,
  ResourceContextProvider,
  Filter,
  SearchInput,
  ShowProps,
} from "react-admin";
import { PaddingDenseStyled2List } from "../../components/ListWrapper";

const ThisFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const VehicleAssign = (props: ShowProps) => {
  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Vehicle Assign</Typography>
      </Grid>
      <Grid item xs={12}>
        <ResourceContextProvider value="vehicles">
          <PaddingDenseStyled2List
            {...props}
            exporter={false}
            hasCreate={false}
            filters={<ThisFilter />}
            filterDefaultValues={{ SubcontractorId: Number(props.id) }}
            bulkActionButtons={false}
            title=" "
          >
            <Datagrid>
              <TextField source="plateNumber" label="Plate No." emptyText="-" />
              <TextField source="iuNumber" emptyText="-" />
              <TextField source="seatCapacity" emptyText="-" />
              <CustomDateField source="registrationDate" emptyText="-" />
            </Datagrid>
          </PaddingDenseStyled2List>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

export default VehicleAssign;
